var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "org_auth",
      attrs: {
        title: _vm.$t("tableFrom.ConfigInfo"),
        visible: _vm.authData.visible,
        "destroy-on-close": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.authData, "visible", $event)
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "orgGroupResForm" },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("tableFrom.sources") } },
            [
              _c("el-tree", {
                ref: "resTree",
                staticStyle: { "background-color": "#ecf5ff" },
                attrs: {
                  data: _vm.resTree,
                  props: _vm.defaultProps,
                  "show-checkbox": !_vm.systemFlag,
                  "node-key": "resId",
                  "highlight-current": "",
                  "default-expand-all": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.systemFlag
        ? _c(
            "el-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "sysOrg:update",
                  expression: "'sysOrg:update'",
                },
              ],
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleOrgGroupResSave()
                },
              },
            },
            [
              _vm._v(
                "\n\t  \t\t" + _vm._s(_vm.$t("buttons.Confirm")) + "\n\t\t\t\t"
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }